//  /statusCode/
import { get, post } from 'src/tools/server';
import { print } from 'graphql';

export const errorTest = (code) => {
  return get<any>(`/test/statusCode/${code}`, {});
};
export const graphql = (query: any, variables: any, params?: any) => {
  return post(
    `graphql`,
    {
      query: print(query),
      variables,
    },
    { ...(params || {}), isGql: true },
  );
};
